import React from 'react';

export default function ServiceCard({ title, children, icon }) {
  // generate a default icon SVG when none is provided
  const genIcon = () => {
    const t = (title || '').toLowerCase();
    if (/kitchen|kitchen/i.test(t))
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <path d="M7 6v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    if (/wardrobe|furniture|furnitur/i.test(t))
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <rect
            x="3"
            y="3"
            width="7.5"
            height="18"
            rx="1"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <rect
            x="13.5"
            y="3"
            width="7.5"
            height="18"
            rx="1"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </svg>
      );
    if (/ceiling|soffit/i.test(t))
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path d="M3 8h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6 12h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    if (/wall|panell|panel/i.test(t))
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <rect x="3" y="4" width="18" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" />
          <path d="M8 4v16" stroke="currentColor" strokeWidth="1" />
        </svg>
      );
    if (/tv|entertainment|media/i.test(t))
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <rect
            x="3"
            y="5"
            width="18"
            height="12"
            rx="1.5"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path d="M8 20h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    // fallback
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    );
  };

  const displayIcon = icon || genIcon();

  return (
    <article className="card p-6 group">
      <div className="w-12 h-12 rounded-md bg-wood flex items-center justify-center text-surface mb-4 shadow-sm group-hover:scale-110 transition-transform duration-300">
        <div className="text-base text-surface">{displayIcon}</div>
      </div>
      <h3 className="font-semibold mb-3 text-lg">{title}</h3>
      <p className="text-sm text-muted text-content">{children}</p>
    </article>
  );
}
